module.exports = __webpack_public_path__ + "img/SEJ eventos_login_right.cc4d98fe.jpg";